export const cleanLogs = (logs, screenName) => {
	const cleanedLogs = logs
		.filter(log =>
			log.entry.agent !== screenName || log.entry.action !== "accessed_whistle")
		.reduce((acc, curr) => {
			const item = { ...curr, ...curr["entry"] }
			return [...acc, item]
		}, [])
	return cleanedLogs
}

export const extractMessages = (logs) => {
	const cleanedLogs = logs
		.filter(el => el.entry.action === "sent_message" || el.entry.action === "added_comment")
		.reduce((acc, curr) => { 
			const item = { ...curr, ...curr["entry"] }
			return [...acc, item]
		}, [])
		.sort((a, b) => a.ts - b.ts);
	return cleanedLogs
} 
